import { transport } from "@/src/config/apiConfig.js";

export default {
  async getTicketSchema() {
    try {
      let res = await transport.get(`/api/tickets/schema`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting ticket schema: ", error);
      throw error;
    }
  },

  async addSchemaAttribute(payload) {
    try {
      let res = await transport.post(`/api/tickets/schema/attributes`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while adding schema attribute: ", error);
      throw error;
    }
  },

  async editSchemaAttribute(slug, payload) {
    try {
      let res = await transport.put(
        `/api/tickets/schema/attributes/${slug}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while editing schema attribute: ",
        error,
      );
      throw error;
    }
  },

  async deleteSchemaAttribute(slug) {
    try {
      let res = await transport.delete(
        `/api/tickets/schema/attributes/${slug}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting schema attribute: ",
        error,
      );
      throw error;
    }
  },

  async addAttributeOption(slug, payload) {
    try {
      let res = await transport.put(
        `/api/tickets/schema/attributes/${slug}/options`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while adding attribute options: ",
        error,
      );
      throw error;
    }
  },

  async addAttributeOptions(slug, payload) {
    try {
      let res = await transport.put(
        `/api/tickets/schema/attributes/${slug}/options/bulk`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while adding attribute options in bulk: ",
        error,
      );
      throw error;
    }
  },

  async getAttributeOptions(slug) {
    try {
      let res = await transport.get(
        `/api/tickets/schema/attributes/${slug}/options`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting attribute options: ",
        error,
      );
      throw error;
    }
  },

  async getSchemaAttributeDetails(slug) {
    try {
      let res = await transport.get(
        `/api/tickets/schema/attributes/${slug}/options`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting attribute details: ",
        error,
      );
      throw error;
    }
  },

  async editAttributeOption(optionId, payload) {
    try {
      let res = await transport.put(
        `/api/tickets/schema/options/${optionId}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while editing attribute option: ",
        error,
      );
      throw error;
    }
  },

  async deleteAttributeOption(optionId) {
    try {
      let res = await transport.delete(
        `/api/tickets/schema/options/${optionId}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting attribute option: ",
        error,
      );
      throw error;
    }
  },

  async getTickets(params = {}) {
    try {
      let res = await transport.get(`/api/tickets`, { params });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting tickets: ", error);
      throw error;
    }
  },

  async getTicketByID(id, params = {}) {
    try {
      let res = await transport.get(`/api/tickets/${id}`, { params });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting ticket by ID: ", error);
      throw error;
    }
  },

  async createTicket(payload) {
    try {
      let res = await transport.post(`/api/tickets`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating ticket: ", error);
      throw error;
    }
  },

  async updateTicket(id, payload) {
    try {
      let res = await transport.patch(`/api/tickets/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating ticket: ", error);
      throw error;
    }
  },

  async deleteTicket(id) {
    try {
      let res = await transport.delete(`/api/tickets/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting ticket: ", error);
      throw error;
    }
  },

  async createTicketRelationship(id, payload) {
    try {
      let res = await transport.post(
        `/api/tickets/${id}/relationships`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating ticket relationship: ",
        error,
      );
      throw error;
    }
  },

  async createTicketRelationships(id, payload) {
    try {
      let res = await transport.post(
        `/api/tickets/${id}/relationships/bulk`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating ticket relationships in bulk: ",
        error,
      );
      throw error;
    }
  },

  async getRelatedObjects(
    id,
    parentObjectType,
    relatedObjectType,
    params = {},
  ) {
    try {
      let res = await transport.get(
        `/api/${parentObjectType}/${id}/relationships/${relatedObjectType}`,
        { params },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting related objects: ", error);
      throw error;
    }
  },

  async deleteTicketRelationship(id) {
    try {
      let res = await transport.delete(`/api/tickets/relationships/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting ticket relationship: ",
        error,
      );
      throw error;
    }
  },

  async createNote(ticketId, payload) {
    try {
      let res = await transport.post(`/api/tickets/${ticketId}/notes`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating note: ", error);
      throw error;
    }
  },

  async updateNote(noteId, payload) {
    try {
      let res = await transport.put(`/api/tickets/notes/${noteId}`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating note: ", error);
      throw error;
    }
  },

  async deleteNote(noteId) {
    try {
      let res = await transport.delete(`/api/tickets/notes/${noteId}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting note: ", error);
      throw error;
    }
  },

  async getTicketActivities(ticketId, params = {}) {
    try {
      let res = await transport.get(`/api/tickets/${ticketId}/activities`, {
        params,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting ticket activities: ",
        error,
      );
      throw error;
    }
  },

  async createTicketActivity(ticketId, engagementId, engagementType) {
    try {
      let res = await transport.post(`/api/tickets/${ticketId}/activities`, {
        engagement_id: engagementId,
        engagement_type: engagementType,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating ticket activity: ", error);
      throw error;
    }
  },

  async importCSV(payload) {
    try {
      let res = await transport.post(`/api/tickets/csvbox/import`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while importing CSV: ", error);
      throw error;
    }
  },

  async getCSVSchema() {
    try {
      let res = await transport.get(`/api/tickets/csvbox/schema`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting CSV schema: ", error);
      throw error;
    }
  },

  async exportCSV(payload) {
    try {
      let res = await transport.post(`/api/tickets/csvbox/export`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while exporting CSV: ", error);
      throw error;
    }
  },

  async downloadCSVExport(exportId) {
    try {
      let res = await transport.get(
        `/api/tickets/csvbox/export/${exportId}/download`,
        {
          responseType: "blob",
        },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while downloading CSV export: ", error);
      throw error;
    }
  },

  async getViewResults(viewId, params = {}, config = {}) {
    try {
      let res = await transport.get(`/api/tickets/views/${viewId}/results`, {
        params,
        ...config,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting view results: ", error);
      throw error;
    }
  },

  async fetchKanbanResults(
    viewId,
    { page = 1, pageSize = 10, option = null, searchQuery = "" } = {},
    config = {},
  ) {
    try {
      const params = new URLSearchParams({
        page_size: pageSize,
        page: page,
      });

      if (option !== null && option !== undefined) {
        params.append("option", option);
      }

      if (searchQuery && searchQuery.trim() !== "") {
        params.append("search_query", searchQuery);
      }

      let res = await transport.get(
        `/api/tickets/views/${viewId}/results/kanban?${params}`,
        config,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching kanban results: ", error);
      throw error;
    }
  },

  async getObjectsWithRelationships(payload) {
    try {
      const res = await transport.post(
        `/api/tickets/relationships/objects-with-relationships`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching objects with relationships: ",
        error,
      );
      throw error;
    }
  },
};
